/* ================================
   PRODUCT VARIANT CLICK
================================ */
// document.addEventListener("click", function (e) {

//   const btn = e.target.closest(".product-card-sizes .size-btn");
//   if (!btn) return;

//   const productCard = btn.closest("product-card, .product-card, product-form-component");
//   if (!productCard) return;

//   const formComponent = productCard.querySelector("product-form-component");
//   if (!formComponent) return;

//   const form = formComponent.querySelector("form");
//   if (!form) return;

//   const variantInput = form.querySelector('input[name="id"]');
//   if (!variantInput) return;

//   const variantId = btn.dataset.variantId;
//   if (!variantId) return;

//   // Update variant
//   variantInput.value = variantId;

//   // Active UI
//   const wrapper = btn.closest(".product-card-sizes");
//   if (wrapper) {
//     wrapper.querySelectorAll(".size-btn").forEach(b => b.classList.remove("active"));
//   }
//   btn.classList.add("active");

//   // Submit form
//   form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
// });


/* ================================
   REVIEW STAR POSITION FIX
================================ */
const starInterval = setInterval(() => {

  const reviews = document.querySelectorAll('.jm-review-item');

  if (reviews.length) {

    reviews.forEach(review => {
      const nameCluster = review.querySelector('.jm-reviewer-info__name-cluster');
      const starRating = review.querySelector('.jm-star-rating');

      if (nameCluster && starRating) {
        if (
          !nameCluster.nextElementSibling ||
          !nameCluster.nextElementSibling.classList.contains('jm-star-rating')
        ) {
          nameCluster.insertAdjacentElement('afterend', starRating);
        }
      }
    });

    clearInterval(starInterval);
  }

}, 400);


/* ================================
   FULL LOOK BUTTON
================================ */
/**
 * Initialize "Add Full Look" functionality for a specific card
 */
// const initFullLookCard = (productCard) => {
//   // Prevent double-initialization
//   if (productCard.dataset.fullLookInitialized === "true") return;
  
//   const button = productCard.querySelector("#add-full-look");
//   if (!button) return;

//   let lastVariantCombination = null;

//   const getVariantCombination = () => {
//     return Array.from(productCard.querySelectorAll('input[name="id"]'))
//       .map(input => Number(input.value));
//   };

//   const disableButton = () => {
//     button.classList.add("is-disabled");
//     button.disabled = true;
//   };

//   const enableButton = () => {
//     button.classList.remove("is-disabled");
//     button.disabled = false;
//   };

//   /* CART CHECK */
//   const checkCartItems = async () => {
//     try {
//       const res = await fetch("/cart.js");
//       const cart = await res.json();
//       const currentVariants = getVariantCombination();

//       const allInCart = currentVariants.every(variantId =>
//         cart.items.some(item => item.id === variantId)
//       );

//       if (allInCart) {
//         disableButton();
//         lastVariantCombination = currentVariants.join("-");
//       }
//     } catch (e) { console.error("Cart check error", e); }
//   };

//   checkCartItems();

//   /* CLICK HANDLER */
//   button.addEventListener("click", (e) => {
//     e.preventDefault();
//     const forms = productCard.querySelectorAll("product-form-component form");
//     forms.forEach(form => {
//       form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
//     });
//     lastVariantCombination = getVariantCombination().join("-");
//     disableButton();
//   });

//   /* VARIANT WATCHER */
//   const variantObserver = new MutationObserver(() => {
//     const current = getVariantCombination().join("-");
//     if (current !== lastVariantCombination) enableButton();
//   });

//   productCard.querySelectorAll('input[name="id"]').forEach(input => {
//     variantObserver.observe(input, { attributes: true, attributeFilter: ["value"] });
//   });

//   // Mark as initialized
//   productCard.dataset.fullLookInitialized = "true";
// };

// /**
//  * Main execution logic
//  */
// const runFullLookLogic = () => {
//   document.querySelectorAll("product-card").forEach(initFullLookCard);
// };

// // 1. Run on initial page load
// document.addEventListener("DOMContentLoaded", runFullLookLogic);

// // 2. Watch for Shopify Section loads (Product Recommendations)
// document.addEventListener("shopify:section:load", runFullLookLogic);

// // 3. Global observer for dynamically injected content (AJAX)
// const globalObserver = new MutationObserver((mutations) => {
//   mutations.forEach((mutation) => {
//     mutation.addedNodes.forEach((node) => {
//       if (node.nodeType === 1) {
//         if (node.tagName === "PRODUCT-CARD") initFullLookCard(node);
//         node.querySelectorAll("product-card").forEach(initFullLookCard);
//       }
//     });
//   });
// });

// globalObserver.observe(document.body, { childList: true, subtree: true });


/* ================================
   DYNAMIC SHIPPING TEXT
================================ */
const sourceEl = document.querySelector('#shippingNotice .shipping-notice-text');
const targetEl = document.querySelector('.shipping-text .details-content');

if (sourceEl && targetEl) {

  targetEl.textContent = sourceEl.textContent;

  const shippingObserver = new MutationObserver(() => {
    targetEl.textContent = sourceEl.textContent;
  });

  shippingObserver.observe(sourceEl, {
    childList: true,
    subtree: true,
    characterData: true
  });
}


/* ================================
   REMOVE GIFT BG
================================ */
const removeBg = () => {
  document.querySelectorAll('.gift-message-container .gift-confirmation')
    .forEach(el => {
      el.style.setProperty('background', 'none', 'important');
    });
};

removeBg();

const bgObserver = new MutationObserver(removeBg);
bgObserver.observe(document.body, { childList: true, subtree: true });



